import * as React from 'react';
import DrupalComponent, { INTERFACE } from './drupal';
import { ExportExternal } from '~sharedComponents/ExternalReference/ExportExternal';

export default ExportExternal<INTERFACE['config']>({
    componentName: 'cartSidebarOffersTab',
    Component: (props) => <DrupalComponent {...props} />
});
